<template>
  <div class="basicTable">
    <el-button
      size="small" type="primary" class="mb10"
      @click="addRow"
    >{{ $t('receivablePayable.AddRow') }}</el-button>

    <el-form
      ref="addFormRef"
      :model="addForm"
      label-width="0"
      size="small"
    >
      <el-table
        :key="key"
        :data="addForm.busList"
        border
        class="error-table"
      >
        <!--业务类型-->
        <el-table-column prop="businessType">
          <template slot="header">
            <div>
              <span style="color: #f00; margin-right: 5px;">*</span>
              <span>{{ $t('collectionCenter.businessT') }}</span>
            </div>
          </template>
          <template slot-scope="scope">
            <div class="formStyle">
              <el-form-item
                :prop="'busList.' + scope.$index + '.businessType'"
                :rules="{ required: true, message: $t('GlobalSetObj.required'), trigger: ['blur', 'change'] }"
              >
                <el-select
                  v-model="scope.row.businessType"
                  :placeholder="$t('basicData.PleaseSelect')"
                  style="width: 100%;"
                  clearable
                  filterable
                  multiple
                  @change="chargeTypeChange(scope)"
                >
                  <el-option
                    v-for="item in getAllBusinessTypes()"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    :disabled="isBusinessTypeDisabled(item.value, scope.$index)"
                  />
                </el-select>
              </el-form-item>
            </div>
          </template>
        </el-table-column>

        <!--业务对接人-->
        <el-table-column prop="businessContact">
          <template slot="header">
            <div>
              <span style="color: #f00;margin-right: 5px;">*</span>
              <span>{{ $t('basicData.BusinessContactPerson') }}</span>
            </div>
          </template>
          <template slot-scope="scope">
            <div class="formStyle">
              <div class="formStyle">
                <el-form-item
                  :prop="'busList.' + scope.$index + '.businessContact'"
                  :rules="{ required: true, message: $t('GlobalSetObj.required'), trigger: ['blur', 'change'] }"
                >
                  <!--                  <QueryUserV2Cmp-->
                  <!--                    :multiple="true" :val="scope.row.businessContact" style="width: 100%;"-->
                  <!--                    @change="val => scope.row.businessContact = val"-->
                  <!--                  />-->
                  <!--                  <el-select-->
                  <!--                    v-model="scope.row.businessContact"-->
                  <!--                    :placeholder="$t('basicData.PleaseSelect')"-->
                  <!--                    style="width: 100%;"-->
                  <!--                    clearable-->
                  <!--                    filterable-->
                  <!--                    multiple-->
                  <!--                    allow-create-->
                  <!--                    default-first-option-->
                  <!--                  >-->
                  <!--                    <el-option-->
                  <!--                      v-for="item in userOptions"-->
                  <!--                      :key="item.value"-->
                  <!--                      :label="item.label"-->
                  <!--                      :value="item.value"-->
                  <!--                    />-->
                  <!--                  </el-select>-->

                  <ElSelectV2
                    v-model="scope.row.businessContact"
                    multiple
                    clearable
                    filterable
                    allow-create
                    default-first-option
                    :options="userOptions"
                    :placeholder="$t('operationCenter.PleaseSelect')"
                    style="width: 100%;"
                  />
                </el-form-item>
              </div>
            </div></template>
        </el-table-column>

        <!--制作人-->
        <el-table-column prop="billCreator">
          <template slot="header">
            <div>
              <span style="color: #f00;margin-right: 5px;">*</span>
              <span>{{ $t('basicData.BillMaker') }}</span>
            </div>
          </template>
          <template slot-scope="scope">
            <div class="formStyle">
              <div class="formStyle">
                <el-form-item
                  :prop="'busList.' + scope.$index + '.billCreator'"
                  :rules="{ required: true, message: $t('GlobalSetObj.required'), trigger: ['blur', 'change'] }"
                >
                  <ElSelectV2
                    v-model="scope.row.billCreator"
                    multiple
                    clearable
                    filterable
                    allow-create
                    default-first-option
                    :options="userOptions"
                    :placeholder="$t('operationCenter.PleaseSelect')"
                    style="width: 100%;"
                  />
                </el-form-item>
              </div>
            </div></template>
        </el-table-column>

        <!--业务审核人-->
        <el-table-column prop="billAuditor">
          <template slot="header">
            <div>
              <span style="color: #f00;margin-right: 5px;">*</span>
              <span>{{ $t('basicData.BillReviewer') }}</span>
            </div>
          </template>
          <template slot-scope="scope">
            <div class="formStyle">
              <div class="formStyle">
                <el-form-item
                  :prop="'busList.' + scope.$index + '.billAuditor'"
                  :rules="{ required: true, message: $t('GlobalSetObj.required'), trigger: ['blur', 'change'] }"
                >
                  <ElSelectV2
                    v-model="scope.row.billAuditor"
                    multiple
                    clearable
                    filterable
                    allow-create
                    default-first-option
                    :options="userOptions"
                    :placeholder="$t('operationCenter.PleaseSelect')"
                    style="width: 100%;"
                  />
                </el-form-item>
              </div>
            </div></template>
        </el-table-column>

        <!--  操作-->
        <el-table-column
          :label="$t('basicData.operate')"
          align="center"
          width="120"
        >
          <template #default="scope">
            <el-popconfirm
              :title="$t('basicData.AreYouSureDelete')"
              @confirm="deleteCost(scope)"
            >
              <!--删除-->
              <el-button
                slot="reference" type="danger"
                size="mini"
              >{{ $t('basicData.Delete') }}</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
  </div>

</template>

<script>
import { CONTRACT_BUSINESS_TYPE } from '@/views/finance/enums';
import { scanUserList } from '@/api/lanshou';
import ElSelectV2 from 'el-select-v2';

export default {
  name: 'BasicTable',

  components: {
    ElSelectV2
  },

  props: {
    tableData: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      CONTRACT_BUSINESS_TYPE,
      key: Date.now(),
      addForm: {
        busList: []
      },
      userOptions: []
    };
  },

  watch: {
    tableData: {
      handler(val) {
        // 防御性编程：确保 val 是数组
        if (!Array.isArray(val) || val.length === 0) {
          // 初始化
          this.addForm.busList = [];
          return;
        }
        this.addForm.busList = val;

        // 数据更新后，清除所有表单验证
        // this.$nextTick(() => {
        //   this.clearAllFormValidate();
        // });
      },
      immediate: true
    }
  },

  created() {
    this.getUserList();
  },

  methods: {
    // 清除所有表单验证
    clearAllFormValidate() {
      if (this.$refs.addFormRef) {
        // 清除表单验证状态
        this.$refs.addFormRef.clearValidate();
      }
    },

    // 验证表单
    validate() {
      return new Promise((resolve, reject) => {
        this.$refs.addFormRef.validate(valid => {
          if (valid) {
            const data = this.addForm.busList;
            resolve(data);
          }
        }).catch(() => {
          reject(false);
        });
      });
    },

    /**
     * 删除
     * @param scope
     */
    deleteCost(scope) {
      const { $index } = scope;
      const deleteItem = () => {
        this.addForm.busList.splice($index, 1);
      };
      deleteItem();

      // if (row.id) {
      //   apiPayableSiteExpenseDelete({ id: scope.row.id })
      //     .then(res => {
      //       if (res.code === 200) {
      //         this.$message.success(this.$t('basicData.TheOperationSucceeded'));
      //         deleteItem();
      //       }
      //     })
      //     .catch(() => {
      //       console.log('删除失败');
      //     });
      // } else {
      //   deleteItem();
      // }
    },

    /**
     * 添加
     */
    addRow() {
      const data = {
        businessType: [], // 业务类型
        businessContact: [], // 业务对接人
        billCreator: [], // 账单制作人
        billAuditor: [] // 账单审核人
      };

      this.addForm.busList.push(data);
      // 刷新key,重置校验状态
      // this.key = Date.now();
    },

    /**
     * 获取所有业务类型（不过滤）
     * @returns {Array} 所有业务类型列表
     */
    getAllBusinessTypes() {
      return Object.values(this.CONTRACT_BUSINESS_TYPE);
    },

    /**
     * 判断业务类型是否应该被禁用
     * @param {string|number} typeValue - 业务类型值
     * @param {number} currentRowIndex - 当前行索引
     * @returns {boolean} 是否禁用
     */
    isBusinessTypeDisabled(typeValue, currentRowIndex) {
      // 检查其他行是否已选择该类型
      for (let idx = 0; idx < this.addForm.busList.length; idx++) {
        // 跳过当前行
        if (idx === currentRowIndex) continue;

        const row = this.addForm.busList[idx];
        // 如果其他行已选择该类型，则禁用
        if (Array.isArray(row.businessType) && row.businessType.includes(typeValue)) {
          return true;
        }
      }

      // 其他行未选择，不禁用
      return false;
    },

    chargeTypeChange(scope) {
      // 此方法保留用于后续扩展，当前禁用逻辑已通过 isBusinessTypeDisabled 实现
      // 当用户取消选中时，其他行的禁用状态会自动更新（响应式）
    },

    /**
     * 用户下拉数据
     */
    getUserList() {
      scanUserList({ accountState: 1 }, false).then(res => {
        const { code, data } = res;
        if (code === 200) {
          this.userOptions = (data || []).map(item => {
            const { realName, id, organizationName, username } = item;
            return Object.freeze({
              value: `${realName}(${username})`,
              label: `${realName}(${username})`
            });
          });
        }
      }).catch(err => {
        this.userOptions = [];
      });
    }
  }
};
</script>

<style scoped lang="scss">

</style>
